import { LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { forceRedirect } from '@methods/forceRedirect'
import { devLog } from '@methods/devLog'
import { API_URL } from '@constants/apiUrl'

export const SaltedgeRedirectPage = observer(() => {
  const store = useContext(StoreContext)

  const initSaltedge = async () => {
    try {
      const { data } = await axiosInstance.post<{ redirectUrl: string }>(
        `${API_URL}/salt-edge/start-session`,
        {},
        {
          withCredentials: true,
        }
      )

      forceRedirect(data.redirectUrl)
    } catch (error) {
      devLog('error: ', error)
    }
  }

  useEffect(() => {
    void initSaltedge()
  }, [])

  return (
    <div className="page-container mobile-m-10">
      <LoadingSpinner />
    </div>
  )
})
